<template>
  <router-link :to="link.path ? link.path : '/'" v-slot="{ href, isActive }">
    <li :class="{ active: isActive || isPartialActive(link) }">
      <slot name="title" v-if="link.path">
        <el-tooltip :content="link.name" placement="top-start" effect="light" :open-delay="500">
          <a :class="{active: isActive}"
             :target="link.target"
             :href="href"
             @click="onItemClick">
            <i :class="link.icon"></i>
            <p>{{link.name}}</p>
          </a>
        </el-tooltip>
      </slot>
    </li>
  </router-link>
</template>
<script>
  export default {
    props: {
      link: {
        type: Object,
        default: () => {
          return {
            name: '',
            path: '',
            children: []
          }
        },
        description: 'Link object'
      }
    },
    inject: {
      autoClose: {default: false},
    },
    methods: {
      onItemClick (evt) {
        this.$emit('click', evt)
        if (this.autoClose) {
          this.$sidebar.showSidebar = false
        }
      },
      isPartialActive(link) {
        try {
          const firstPart = link.path.split('/')[1]
          let path = `/${firstPart.split('?')[0]}`
          return this.$route.path.startsWith(path)
        } catch (e) {
          return false
        }
      }
    }
  }
</script>
